import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ControlledAutocompleteDropdown } from 'src/shared/components/form/controlledAutocompleteDropdown';
import { VatRateEnum } from 'src/shared/models/enums/vatRate.enum';

type VatRateStructure = {
  vatRate: VatRateEnum;
  label: string;
};

type VatRateSelectorProps = {
  name: string;
  disable?: boolean;
  ticketForm?: boolean;
};

export const VatRateSelector = (props: VatRateSelectorProps) => {
  const { name, disable = false, ticketForm = false } = props;
  const { t } = useTranslation();

  const { setValue, watch } = useFormContext();

  const VatRates: VatRateStructure[] = useMemo(() => {
    return [
      {
        vatRate: VatRateEnum.Zero,
        label: !ticketForm ? t('invoice:vatRate.zero') : t('invoice:vatRateTicket.zero'),
      },
      {
        vatRate: VatRateEnum.Six,
        label: !ticketForm ? t('invoice:vatRate.six') : t('invoice:vatRateTicket.six'),
      },
      {
        vatRate: VatRateEnum.Twelve,
        label: !ticketForm ? t('invoice:vatRate.twelve') : t('invoice:vatRateTicket.twelve'),
      },
      {
        vatRate: VatRateEnum.TwentyFive,
        label: !ticketForm ? t('invoice:vatRate.twentyFive') : t('invoice:vatRateTicket.twentyFive'),
      },
    ];
  }, [t, ticketForm]);

  const currentVatRate = watch(name) as VatRateEnum | undefined;

  const placeholder = useMemo(() => {
    const match = VatRates.find((v) => v.vatRate === currentVatRate);
    if (match) return match.label;
    return !ticketForm ? t('invoice:vatRate.zero') : t('invoice:vatRateTicket.zero');
  }, [VatRates, currentVatRate, ticketForm, t]);

  return (
    <ControlledAutocompleteDropdown
      disable={disable}
      componentWidth='100%'
      placeholder={placeholder}
      label={t('invoice:vatIncluded')}
      nameProp='label'
      name={name}
      options={VatRates}
      callback={(val) => {
        if (val) {
          setValue(name, val.vatRate);
        } else {
          setValue(name, VatRateEnum.Zero);
        }
      }}
    />
  );
};
